import type { FaireProductEntity } from "../../entity_types/product";

export const p_p34te2qydc: FaireProductEntity = {
  token: "p_p34te2qydc",
  type: "product",
  name: "Solid Knit Open-Front Pocketed Cardigan",
  brandToken: "b_b5qvtl6s4w",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b08706bd7d986b000b9ac69bd427cdc58804178986cd379981ad084f69d637f3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/30f4127798da9043fdb996770a351e1b2050e288f9d14ee174c5c7e09b81d007.jpeg",
    "https://cdn.faire.com/fastly/38eab0b8f13fc87481baaeaf359c4164c8f60d28ff8938f49423d32c77532cba.jpeg",
    "https://cdn.faire.com/fastly/c30eb3f84f2f5fc8690f9f72b77e4c10fcf1e6b7e89eb611042aa6f897ed81ed.jpeg",
    "https://cdn.faire.com/fastly/66b3d858b1a2b7b8832bf284fd3bd6705118a991a3fad3ad61756376eb58171a.jpeg",
    "https://cdn.faire.com/fastly/67489a594de095572b75c37ebd925cbd373e6777f74312ad834e939c36fc6bc7.jpeg",
    "https://cdn.faire.com/fastly/3a30a4d23e1ffe8824af850a49dc9db17f0ea23f5fec165286a835b7eec110ad.jpeg",
    "https://cdn.faire.com/fastly/ce41f27c8062983fcb096f284fa298d336ca892b1f5436d2f5864bff3af8be63.jpeg",
    "https://cdn.faire.com/fastly/7a5f73557f058653717251612a26904b5d4dcfe77448a329bb983fb9b0ad5ee0.jpeg",
    "https://cdn.faire.com/fastly/831ef1bad04377e50422869235e96c3cd50654f29bc18038ac0f99aa32f9dbd5.png",
  ],
  priceDollars: 38,
  description:
    "Elevate your transitional wardrobe with this cardigan, crafted in a breathable open knit design that's both stylish and easy to layer. Featuring functional pockets, it combines practical convenience with a relaxed, casual vibe. Its solid shade offers versatile pairing options, making it an essential layering piece for shifting seasons. Acrylic/Cotton\n\n\nSize Info:\nSee size chart for approximate measurements.\n\nSeason: Fall, Winter, Spring, Summer\n\n",
  tags: [],
  msrpDollars: 76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:12.661Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
